const ABProcessLaneCore = require("../../core/process/ABProcessLaneCore");
module.exports = class ABProcessLane extends ABProcessLaneCore {};
